import { render, staticRenderFns } from "./tableReports.vue?vue&type=template&id=00ab67e1&"
import script from "./tableReports.js?vue&type=script&lang=js&"
export * from "./tableReports.js?vue&type=script&lang=js&"
import style0 from "./tableReports.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports